var map = {
	"./allenImage.png": 24,
	"./android-chrome-192x192.png": 25,
	"./android-chrome-512x512.png": 26,
	"./apple-touch-icon.png": 27,
	"./candaceImage.png": 28,
	"./candanceImage.png": 29,
	"./chessImage.png": 11,
	"./chrisImage.png": 30,
	"./computerImage.png": 13,
	"./diamond.png": 6,
	"./favicon-16x16.png": 31,
	"./favicon-32x32.png": 32,
	"./grantImage.png": 33,
	"./greyBackdrop.png": 12,
	"./homerImage.png": 34,
	"./image.png": 35,
	"./jimImage.png": 36,
	"./logo.png": 9,
	"./luisImage.png": 37,
	"./martinImage.png": 38,
	"./mauricioImage.png": 39,
	"./mikeImage.png": 40,
	"./milen.png": 41,
	"./oval.png": 42,
	"./pentagon.png": 5,
	"./quotes.png": 8,
	"./randyImage.png": 43,
	"./robertImage.png": 44,
	"./sideCircle.png": 45,
	"./star.png": 3,
	"./stationImage.png": 7,
	"./sunilImage.png": 46,
	"./tedImage.png": 47,
	"./toddImage.png": 48,
	"./triangle.png": 4,
	"./unknown.png": 49,
	"./unknownOne.png": 50
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;